import _ws from "@netuno/ws-client";

let data = {
  externalCode: sessionStorage.getItem("externalCode"),
  metadata: {
    cityUid: null,
    priceFrom: null,
    priceTo: null,
  },
};

export default class Core {
  static data() {
    return data;
  }

  static externalCode() {
    const code = sessionStorage.getItem("externalCode");
    data.externalCode = code;
    return code;
  }

  /**static getContext() {
       

        this.listenerGetContext = _ws.addListener({
            service: 'remote/context',
            success: (res) => {
                console.log("res:", res.content)
                data.metadata = res.content;
                data.metadata.cityUid = '61493f02-3ac5-4624-87a3-b4ac518bfea4';
            },
            fail: (error) => {
                console.log(error)
            }
        });

        _ws.sendService({
            service: 'remote/context',
            data: { externalCode }
        });
    }*/

  static getContext(settings) {
    const externalCode = Core.externalCode();

    const success = settings.onSuccess ? settings.onSuccess : () => {};
    const fail = settings.onFail ? settings.onFail : () => {};

    this.listenerContext = _ws.addListener({
      service: "remote/context",
      success: (res) => {
        console.log("res:", res.content);
        data.metadata = res.content;
        success();
        _ws.removeListener(this.listenerContext);
      },
      fail: (error) => {
        fail();
        _ws.removeListener(this.listenerContext);
        console.log(error);
      },
    });
    _ws.sendService({
      service: "remote/context",
      data: { externalCode },
    });

    /**const configs = {
            method: 'GET',
            credentials: 'include',
            headers: {
                "Content-Type": 'application/json',
                "Accept": 'application/json'
            },
        };
        fetch(config.workflowForms.remontraEndpoint + `/remote/context/get?externalCode=${externalCode}`, configs).then(
            (response) => {
                if (response.ok) {
                    if (response.status === 204) {

                        console.log("1")
                        return success();
                    } else {
                        const contentType = response.headers.get("Content-Type")
                        if (contentType && contentType.toLowerCase().indexOf("application/json") === 0) {
                            console.log("2")
                            
                            return response.json().then(function (data) {
                                data.metadata = data;
                                data.metadata.cityUid = '61493f02-3ac5-4624-87a3-b4ac518bfea4';

                                success({ json: data })
                            });
                        } else {
                            console.log("3");
                            return response.text().then(function (text) {
                                success({ text: text })
                            });
                        }
                    }
                } else {
                    return fail({ response: response });
                }
            }
        ).catch((e) => {
            fail({ error: e });
        });*/
  }

    static notification({type, title, message}) {
        const div = document.createElement("div");
        div.classList.add('notification');
        div.classList.add('notification--'+ type);
        const h4 = document.createElement("h4");
        h4.appendChild(document.createTextNode(title));
        div.appendChild(h4);
        div.appendChild(document.createTextNode(message));
        document.getElementsByTagName('body')[0].appendChild(div);
        window.setTimeout(() => {
            div.remove();
        }, 5000);
    }
}
